export const isPasswordValid = (password: string) => {
  const matches = RegExp(/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/).exec(password);
  return matches !== null;
};
